import EditableCell from './editable-cell/editable-cell-container';
import LinkCell     from './link-cell/link-cell-container';

export {
	EditableCell,
	LinkCell
}


// WEBPACK FOOTER //
// ./src/component/react-table/index.js